// ============================================================
// ABU ZAMA SOCCER ACADEMY — EDITABLE CONTENT LAYER
// Edit prices, programs, age groups, coaches, events,
// testimonials, gallery and contact info here without
// touching any component code.
// These values are the DEFAULTS — anything saved from the
// /admin dashboard (stored in MongoDB) overrides them.
// ============================================================

export const CONTACT = {
  academyName: 'Abu Zama Soccer Academy',
  shortName: 'ASA',
  tagline: ['Developing Players.', 'Building Champions.', 'Inspiring Leaders.'],
  phoneDisplay: '734-353-8112',
  whatsapp: 'https://wa.me/17343538112?text=Hello%20ASA!%20I%27d%20like%20to%20learn%20more%20about%20Abu%20Zama%20Soccer%20Academy.',
  email: 'Sulimanabuzema@gmail.com',
  instagram: 'https://www.instagram.com/abuzamaacademy/',
  instagramHandle: '@abuzamaacademy',
  location: '7546 Baron Dr, Canton, MI 48187, USA',
  mapsEmbed: 'https://www.google.com/maps?q=7546+Baron+Dr,+Canton,+MI+48187&output=embed',
  mapsLink: 'https://www.google.com/maps/dir/?api=1&destination=7546+Baron+Dr,+Canton,+MI+48187',
};

export const ASSETS = {
  logo: '/assets/asa-logo.jpeg',
  squadBanner: '/assets/squad-banner.jpeg',
  heroSquad: '/assets/hero-squad.jpeg',
  heroPoster: '/assets/hero-poster.webp',
  coachSuleiman: '/assets/coach-suleiman.jpeg',
};

export const NAV_LINKS = [
  { label: 'Home', hash: '#home' },
  { label: 'About', hash: '#why' },
  { label: 'Programs', hash: '#programs' },
  { label: 'Age Groups', hash: '#age-groups' },
  { label: 'Coaches', hash: '#coaches' },
  { label: 'Gallery', hash: '#gallery' },
  { label: 'Contact', hash: '#contact' },
];

export const HERO = {
  headline: ['Developing Players.', 'Building Champions.', 'Inspiring Leaders.'],
  subheadline: 'Premium youth soccer development for boys and girls ages 5–16 in Canton, Michigan.',
  supporting: 'Technical excellence. Tactical intelligence. Mental resilience. Character.',
  trustLine: ['Professional Coaching', 'Small Group Training', 'Ages 5–16', 'Canton, Michigan'],
};

export const STATS = [
  { value: '5–16', label: 'Age Range' },
  { value: 'MAX 14', label: 'Outfield Players Per Coach' },
  { value: '1', label: 'Goalkeeper Per Coach' },
  { value: 'PRO', label: 'Coaching Staff' },
];

export const WHY_FEATURES = [
  { icon: 'Target', title: 'Technical Mastery', text: 'Ball control, passing, dribbling, first touch and finishing.' },
  { icon: 'Brain', title: 'Tactical Intelligence', text: 'Game awareness, positioning, decision-making and understanding space.' },
  { icon: 'Zap', title: 'Physical Development', text: 'Speed, agility, coordination, balance and match fitness.' },
  { icon: 'Shield', title: 'Mental Resilience', text: 'Confidence, focus, discipline and the ability to perform under pressure.' },
  { icon: 'Crown', title: 'Character & Leadership', text: 'Respect, responsibility, humility and leadership.' },
  { icon: 'Users', title: 'Team & Community', text: 'Teamwork, friendship, sportsmanship and a strong sense of community.' },
];

export const PHILOSOPHY_VALUES = [
  'Discipline', 'Respect', 'Confidence', 'Humility', 'Hard Work', 'Teamwork', 'Leadership', 'Sportsmanship',
];

export const PHILOSOPHY_STEPS = ['Discover', 'Develop', 'Compete', 'Lead', 'Excel'];

export const AGE_GROUPS = [
  { group: 'U6', ages: 'Ages 5–6', focus: 'First touches, coordination and falling in love with the ball through fun, game-based learning.' },
  { group: 'U8', ages: 'Ages 7–8', focus: 'Ball mastery fundamentals — dribbling, control and confidence in 1v1 situations.' },
  { group: 'U10', ages: 'Ages 9–10', focus: 'Passing combinations, first touch under pressure and introduction to positional play.' },
  { group: 'U12', ages: 'Ages 11–12', focus: 'Tactical awareness, decision-making speed and understanding space on both sides of the ball.' },
  { group: 'U14', ages: 'Ages 13–14', focus: 'High-intensity training, game intelligence and competitive match preparation.' },
  { group: 'U16', ages: 'Ages 15–16', focus: 'Elite-level refinement, position-specific development and preparation for higher competition.' },
];

export const PACKAGES = [
  {
    id: 'development',
    name: 'Development',
    price: 150,
    cadence: '2 Days Per Week',
    blurb: 'Build strong fundamentals and develop confidence on the ball.',
    features: [
      '2 Training Days Per Week', 'Technical Fundamentals', 'Ball Control', 'Passing', 'Dribbling',
      'Finishing', 'Basic Game Understanding', 'Professional Coaching', 'Positive & Motivational Environment',
    ],
    cta: 'Register Now',
    badge: null,
  },
  {
    id: 'advanced',
    name: 'Advanced',
    price: 180,
    cadence: '3 Days Per Week',
    blurb: 'Accelerate technical and tactical development through increased training frequency.',
    features: [
      '3 Training Days Per Week', 'Advanced Technical Development', 'Tactical Awareness', 'Game Intelligence',
      'High-Intensity Training', 'Ball Mastery', 'Passing & Finishing', 'Performance Development', 'Professional Coaching',
    ],
    cta: 'Register Now',
    badge: 'Most Popular',
  },
  {
    id: 'elite',
    name: 'Elite',
    price: 210,
    cadence: '3 Days Per Week + 1 Private Session',
    blurb: 'Designed for players seeking a more intensive and personalized development experience.',
    features: [
      '3 Training Days Per Week', '1 Private Training Session Per Month', 'Individualized Player Development',
      'Advanced Technical Development', 'Advanced Tactical Training', 'High-Intensity Competitive Preparation',
      'Personalized Coaching Feedback', 'Player Development Guidance', 'Higher-Level Development Pathway',
    ],
    cta: 'Join Elite',
    badge: null,
    elite: true,
  },
  {
    id: 'private-group',
    name: 'Private + Group',
    price: 35,
    per: 'Session',
    cadence: 'Private Session Within a Small Group',
    blurb: 'A focused private training session delivered inside a small group setting.',
    features: [
      '1 Private Training Session', 'Small Group Setting', 'High-Repetition Technical Work',
      'Professional Coaching', 'Personalized Feedback',
    ],
    cta: 'Book Now',
    badge: null,
  },
  {
    id: 'private-captain',
    name: 'Private With The Captain',
    price: 50,
    per: 'Session',
    cadence: 'One-On-One With The Head Coach',
    blurb: 'A fully private one-on-one session with the Captain — maximum individual attention.',
    features: [
      '1 Private 1-on-1 Session', 'Personally With The Head Coach', 'Individualized Development Focus',
      'Advanced Technical & Tactical Work', 'Detailed Coaching Feedback',
    ],
    cta: 'Book Now',
    badge: null,
  },
];

export const GIRLS_WINTER = {
  name: 'Girls Winter Soccer Training',
  flyer: '/assets/girls-winter.jpeg',
  blurb: 'Professional soccer training to sharpen girls\u2019 soccer skills and get them ready for the spring season!',
  schedule: 'Tuesdays & Thursdays — 6:00 PM to 7:30 PM',
  location: '7546 Baron Dr, Canton, MI 48187',
  period: 'Practice starts the week of November 9 and runs through March',
  priceIntro: '$100 for November — then $120 per month',
  paymentNote: 'Payment due at the beginning of each month',
  spots: '14 spots available — first come, first serve!',
  focus: ['Skill Development', 'Technical Training', 'Game Preparation', 'Confidence & Growth'],
  motto: 'Train • Improve • Compete • Get Ready for Spring!',
  months: [
    { month: 'November', dates: 'Nov 10, 12, 17, 19, 24', paymentDue: '$100 — November 1' },
    { month: 'December', dates: 'Dec 1, 3, 8, 10, 15, 17, 23', paymentDue: 'December 1' },
    { month: 'January', dates: 'Jan 5, 7, 12, 14, 19, 21, 26, 28', paymentDue: 'January 1' },
    { month: 'February', dates: 'Feb 2, 4, 9, 11, 16, 18, 23, 25', paymentDue: 'February 1' },
    { month: 'March', dates: 'Mar 2, 4, 9, 11, 16, 18, 23, 25', paymentDue: 'March 1' },
  ],
};

export const PROGRAMS = [
  {
    icon: 'ClipboardCheck',
    title: 'Player Evaluation',
    blurb: 'Know where your player stands.',
    items: ['Technical Ability', 'Tactical Understanding', 'Physical Attributes', 'Decision Making', 'Mental Approach', 'Areas for Improvement'],
    cta: 'Book Player Evaluation',
    program: 'Player Evaluation',
  },
  {
    icon: 'User',
    title: 'Private 1-on-1 Training',
    blurb: 'Personalized training designed around the player’s individual goals.',
    items: ['Ball Mastery', 'First Touch', 'Dribbling', 'Passing', 'Finishing', 'Speed', 'Position-Specific Development'],
    cta: 'Book Private Training',
    program: 'Private 1-on-1 Training',
  },
  {
    icon: 'Users',
    title: 'Small Group Training',
    blurb: 'High-quality training for small groups with maximum individual attention.',
    items: ['Repetition', 'Technical Development', 'Decision-Making', 'Game Situations'],
    cta: 'Book Group Training',
    program: 'Small Group Training',
  },
  {
    icon: 'Hand',
    title: 'Goalkeeper Development',
    blurb: 'Specialized goalkeeper training with a dedicated coach ratio.',
    items: ['Shot Stopping', 'Positioning', 'Footwork', 'Reactions', 'Distribution', '1v1 Situations', 'Communication'],
    cta: 'Goalkeeper Program',
    program: 'Goalkeeper Development',
  },
  {
    icon: 'Tent',
    title: 'Soccer Camps & Clinics',
    blurb: 'Seasonal programs throughout the year — summer camps, school breaks and technical clinics.',
    items: ['Summer Soccer Camp', 'Spring Break Camp', 'Holiday Clinics', 'School Break Training', 'Technical Clinics'],
    cta: 'Book Now',
    program: 'Camps & Clinics',
  },
];

export const PATHWAY = [
  { stage: 'Foundation', ages: 'Ages 5–8', text: 'Love the ball. Coordination, balance and joyful first touches.' },
  { stage: 'Development', ages: 'Ages 9–11', text: 'Master the fundamentals. Technique, passing and game understanding.' },
  { stage: 'Competition', ages: 'Ages 12–14', text: 'Compete with intelligence. Tactics, intensity and mental strength.' },
  { stage: 'Elite', ages: 'Ages 15–16', text: 'Perform at the highest level. Position-specific, high-performance training.' },
  { stage: 'Next Level', ages: 'Beyond ASA', text: 'Preparation and pathways toward higher levels of competition.' },
];

export const PATHWAY_DESTINATIONS = [
  'Competitive Soccer', 'High School Soccer', 'College Soccer', 'Advanced Academy Opportunities', 'Professional Development',
];

export const COACHES = [
  {
    role: 'Technical Director',
    name: 'Coach Abdullah Abu Zama',
    credentials: 'AFC Pro License | FIFA Football Legend | Former Jordan National Team Captain',
    bio: 'Captain Abdullah Abu Zama is a respected Jordanian football figure and former captain of the Jordan National Football Team. Recognized by FIFA as a Football Legend, he brings international football experience and elite coaching vision to Abu Zama Soccer Academy.',
    image: '/assets/coach-abdullah.jpeg',
    imagePos: 'center 14%',
    monogram: 'AZ',
    resumeUrl: '/assets/resume-abdullah.pdf',
  },
  {
    role: 'Head Coach',
    name: 'Coach Suleiman Abu Zama',
    credentials: 'AFC B License | Former Jordan U-23 National Team Player',
    bio: 'With more than 15 years of professional soccer experience, Coach Suleiman Abu Zama leads ASA’s day-to-day training operations. His sessions focus on technical development, tactical intelligence, discipline, confidence and competitive mentality.',
    image: '/assets/coach-suleiman.jpeg',
    monogram: 'SZ',
    resumeUrl: '/assets/resume-suleiman.pdf',
  },
];

export const SMALL_GROUP_BENEFITS = [
  'More touches', 'More repetitions', 'More coaching feedback', 'More individual attention', 'Better development tracking',
];

export const CHARACTER_VALUES = ['Respect', 'Discipline', 'Integrity', 'Humility', 'Leadership', 'Excellence'];

export const PARENT_PROMISE = [
  { icon: 'ShieldCheck', title: 'Safe & Positive Environment' },
  { icon: 'Award', title: 'Professional Coaching' },
  { icon: 'TrendingUp', title: 'Clear Player Development' },
  { icon: 'Eye', title: 'Individual Attention' },
  { icon: 'MessageSquare', title: 'Consistent Communication' },
  { icon: 'Handshake', title: 'Respect & Discipline' },
  { icon: 'LineChart', title: 'Progress Tracking' },
  { icon: 'Heart', title: 'Strong Community' },
];

export const PROGRESS_SKILLS = [
  { skill: 'Technical', level: 82 },
  { skill: 'Tactical', level: 74 },
  { skill: 'Physical', level: 88 },
  { skill: 'Mental', level: 79 },
  { skill: 'Teamwork', level: 91 },
  { skill: 'Leadership', level: 68 },
];

export const TESTIMONIALS = [
  { placeholder: true, quote: 'Family review coming soon. This space is reserved for real feedback from ASA parents.', label: 'ASA Parent — Placeholder' },
  { placeholder: true, quote: 'Family review coming soon. This space is reserved for real feedback from ASA players.', label: 'ASA Player — Placeholder' },
  { placeholder: true, quote: 'Family review coming soon. This space is reserved for real feedback from ASA families.', label: 'ASA Family — Placeholder' },
];

export const GALLERY_CATEGORIES = ['All', 'Training', 'Matches', 'Players', 'Coaches', 'Camps', 'Community', 'Events'];

export const GALLERY = [
  { src: '/assets/squad-banner.jpeg', category: 'Players', alt: 'ASA official squad at the stadium' },
  { src: '/assets/coach-suleiman.jpeg', category: 'Coaches', alt: 'Head Coach Suleiman Abu Zama on the training pitch' },
  { src: '/assets/coach-abdullah.jpeg', category: 'Coaches', alt: 'Technical Director Coach Abdullah Abu Zama' },
  { src: '/assets/girls-winter.jpeg', category: 'Events', alt: 'Girls Winter Soccer Training program' },
  { src: 'https://images.unsplash.com/photo-1610736342165-4eeb4aef66ca?auto=format&fit=crop&w=1200&q=80', category: 'Training', alt: 'Youth player striking the ball in training' },
  { src: 'https://images.pexels.com/photos/35227280/pexels-photo-35227280.jpeg?auto=compress&cs=tinysrgb&w=1200', category: 'Matches', alt: 'Match-day action' },
  { src: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?auto=format&fit=crop&w=1200&q=80', category: 'Training', alt: 'Player dribbling at speed' },
  { src: 'https://images.pexels.com/photos/30651230/pexels-photo-30651230.jpeg?auto=compress&cs=tinysrgb&w=1200', category: 'Events', alt: 'Stadium lights on event night' },
  { src: 'https://images.pexels.com/photos/4135333/pexels-photo-4135333.jpeg?auto=compress&cs=tinysrgb&w=1200', category: 'Camps', alt: 'Floodlit evening training camp' },
  { src: 'https://images.unsplash.com/photo-1517747614396-d21a78b850e8?auto=format&fit=crop&w=1200&q=80', category: 'Community', alt: 'Stadium under the lights from above' },
];

export const EVENTS = [
  {
    name: 'Summer Technical Clinic', type: 'Clinic',
    date: 'Monday, July 27, 2026', time: '6:00 PM – 7:30 PM',
    location: '7546 Baron Dr, Canton, MI 48187', ages: 'Ages 7–14', price: '$25',
    description: 'A focused 90-minute ball mastery and finishing clinic led by Coach Suleiman Abu Zama.',
  },
  {
    name: 'Summer Soccer Camp — Week 2', type: 'Camp',
    date: 'August 10–14, 2026', time: '9:00 AM – 12:00 PM',
    location: '7546 Baron Dr, Canton, MI 48187', ages: 'Ages 6–14', price: '$150 / week',
    description: 'Five mornings of technical training, small-sided games, character sessions and competitions.',
  },
  {
    name: 'Player Evaluation Day', type: 'Tryout',
    date: 'Saturday, August 22, 2026', time: '10:00 AM – 12:00 PM',
    location: '7546 Baron Dr, Canton, MI 48187', ages: 'Ages 5–16', price: 'Free',
    description: 'Open evaluation for new players — technical, tactical, physical and mental assessment by ASA staff.',
  },
  {
    name: 'Goalkeeper Development Clinic', type: 'Clinic',
    date: 'Saturday, September 12, 2026', time: '11:00 AM – 12:30 PM',
    location: '7546 Baron Dr, Canton, MI 48187', ages: 'Ages 8–16', price: '$25',
    description: 'Shot stopping, positioning, footwork and distribution with specialized goalkeeper coaching.',
  },
  {
    name: 'ASA Family & Community Day', type: 'Community',
    date: 'Saturday, September 19, 2026', time: '12:00 PM – 4:00 PM',
    location: '7546 Baron Dr, Canton, MI 48187', ages: 'All Ages', price: 'Free',
    description: 'Open house, small-sided games, meet the coaches and celebrate the ASA community.',
  },
  {
    name: 'Winter Holiday Clinic', type: 'Clinic',
    date: 'December 28–30, 2026', time: '10:00 AM – 12:00 PM',
    location: '7546 Baron Dr, Canton, MI 48187', ages: 'Ages 6–14', price: '$75',
    description: 'Three days of indoor technical training during the school holiday break.',
  },
];

export const TRYOUT = {
  headline: 'Ready for the Next Level?',
  text: 'Give your player the opportunity to train, compete and grow in a professional development environment.',
  process: [
    { step: '01', title: 'Register Online', text: 'Submit the player evaluation form below in under two minutes.' },
    { step: '02', title: 'Attend Evaluation', text: 'Your player joins an active ASA training group at our field — 7546 Baron Dr, Canton.' },
    { step: '03', title: 'Professional Assessment', text: 'Coaches assess technical, tactical, physical and mental attributes.' },
    { step: '04', title: 'Placement & Plan', text: 'Receive honest feedback and a recommended development pathway.' },
  ],
  bring: ['Soccer cleats & shin guards', 'Water bottle', 'Size 4 or 5 ball (optional)', 'Positive attitude & energy'],
  expectations: ['Arrive 15 minutes early', '90-minute evaluation session', 'Players grouped by age', 'Parents welcome to observe'],
  dates: ['Saturday, August 22, 2026 — 10:00 AM', 'Saturday, August 29, 2026 — 10:00 AM', 'Rolling evaluations every week — contact us'],
};

export const WAIVER_TEXT = 'I, the undersigned participant (or parent/legal guardian if the participant is a minor), acknowledge and understand that participation in athletic training and soccer activities involves inherent risks, including but not limited to physical injury, illness, permanent disability, or death, and I voluntarily assume all such risks; in consideration for being allowed to participate, I hereby fully release, waive, and hold harmless Abu Zama Academy, its owners, coaches, staff, contractors, and volunteers from any and all claims, liabilities, damages, or expenses arising out of or related to participation, including those resulting from ordinary negligence; I consent to emergency medical treatment if necessary and accept full responsibility for any related costs; I agree to abide by all rules, instructions, and standards of conduct, understanding that failure to do so may result in removal without refund; and I grant permission for the use of the participant\u2019s image or video for lawful promotional purposes; by signing, I confirm that I have read this agreement carefully, understand its terms, and sign it freely and voluntarily.';

export const PROGRAM_OPTIONS = [
  'Development — $150/month (2 days/week)',
  'Advanced — $180/month (3 days/week)',
  'Elite — $210/month (3 days/week + 1 private session)',
  'Private + Group Session — $35/session',
  'Private With The Captain — $50/session',
  'Girls Winter Training — $100 November, then $120/month',
  'Player Evaluation',
  'Private 1-on-1 Training',
  'Small Group Training',
  'Goalkeeper Development',
  'Camps & Clinics',
];

export const MARQUEE_ITEMS = ['Developing Players', 'Building Champions', 'Inspiring Leaders', 'Respect', 'Discipline', 'Integrity', 'Humility', 'Excellence'];
